import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=615ad75e&scoped=true"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminComponent.vue?vue&type=style&index=0&id=615ad75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ad75e",
  null
  
)

export default component.exports